export default {
    title_list: 'Site content',
    title_page: 'Site page',
    title_create_page: 'Create site page',
    title_edit_page: 'Change site page',

    filter: {
        labels: {
            title: 'Title',
        }
    },

    table: {
        labels: {
            id: 'ID',
            link: 'Link',
            title: 'Title',
        }
    },

    buttons: {

    },

    form: {
        slug: 'Slug',
        link: 'Link',
        title: 'Title',
        description: 'Page Description',
        meta_title: 'Browser Tab Title',
        meta_description: 'Description for search engines',
        meta_keywords: 'Keywords',
        meta_social_title: 'Social media header',
        meta_social_description: 'Description for social networks',
        meta_social_image: 'Image for social networks',
    },
}
